import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'pi-tag-picker',
  templateUrl: './tag-picker.component.html',
  styleUrls: ['./tag-picker.component.css']
})
export class TagPickerComponent implements OnInit, OnChanges {
  @Input() selectMode: 'default' | 'multiple' = 'default';
  @Input() formControlName: string;
  @Input() tagType: string;
  @Output() tagTypeChange = new EventEmitter<any>();
  @Input() ngModel: any;
  @Output() ngModelChange = new EventEmitter<any>();
  @Output() labelMapChange = new EventEmitter<any>();
  tagList: any = [];
  result;
  showSelect = false;
  labelMap: any;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.tagType) {
      this.showSelect = true;
    } else {
      this.showSelect = false;
    }
    this.loadData();
  }

  async loadData() {
    this.labelMap = {};
    if (this.tagList) {
      this.tagList.forEach(data => {
        this.labelMap[data.id] = data.tagName;
      });
      this.labelMapChange.emit(this.labelMap);
    }
  }

  setTagType($event) {
    // this.tagType = $event;
    this.showSelect = true;
    this.tagTypeChange.emit($event);
  }

  setTagList($event) {
    this.tagList = $event;
    this.loadData();
  }

  showTagTypeSelector() {
    this.showSelect = false;
    this.ngModel = null;
  }

  onTagSet($event) {
    this.ngModelChange.emit($event);
  }
}
